module.exports = __webpack_public_path__ + "media/contractor-reporting/simple-payroll-exports-f6d29b69.png";